module.exports = __webpack_public_path__ + "img/borders2.40623ac6.png";